<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('mina')">Orden de Despacho Nº:</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ form.id }}
    </h1>
    <trashed-message v-if="orden.deleted_at" class="mb-6" @restore="restore">
     Orden de Despacho Removed!
    </trashed-message>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
         <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <select-input v-model="form.maquinaria_id" :error="form.errors.maquinaria_id" class="pr-6 pb-8 w-full lg:w-1/3" label="Maquinaria/Vehiculo" required disabled>
            <option v-for="maquinaria in maquinarias" :key="maquinaria.id" :value="maquinaria.id">{{ maquinaria.codigo }} - {{ maquinaria.clase}} - {{maquinaria.placas}}</option>
        </select-input>
        <select-input v-model="form.operador" :error="form.errors.operador" class="pr-6 pb-8 w-full lg:w-1/3" label="Operador" required disabled>
            <option v-for="conductor in conductores" :key="conductor.id">{{ conductor.nombres }} {{ conductor.apellidos }}</option>
        </select-input>
        <select-input v-model="form.proyecto" :error="form.errors.proyecto" class="pr-6 pb-8 w-full lg:w-1/3" label="Destino de Proyecto" required disabled>
            <option v-for="proyecto in proyectos" :key="proyecto.id">{{ proyecto.nombre}}</option>
        </select-input>
           <select-input v-model="form.material" :error="form.errors.material" class="pr-6 pb-8 w-full lg:w-1/3" label="Tipo de Material" required disabled>
            <option>BASE CRIBADA</option>  
             <option>BASE TRITURADA</option>
             <option>RIPIO</option>
            <option>SUB-BASE</option>
            <option>PIEDRA BOLA</option>
            <option>ESCOLLERA</option>
            <option>MEJORAMIENTO</option>
            <option>POLVO DE PIEDRA</option>
            <option>ARENA AZUL LAVADA</option>
        </select-input>
        <text-input v-model="form.capacidad" :error="form.errors.capacidad" class="pr-6 pb-8 w-full lg:w-1/3" label="Capacidad M3" required disabled/>
        <select-input v-model="form.proveedor" :error="form.errors.proveedor" class="pr-6 pb-8 w-full lg:w-1/3" label="Proveedor" required disabled>
            <option>PETRUSMIN</option>
        </select-input>

         <select-input v-if="$page.props.auth.user.rol =='Admin'" v-model="form.cliente" :error="form.errors.cliente" class="pr-6 pb-8 w-full lg:w-2/5" label="Cliente Facturador" required disabled>
            <option>GUADALUPECONST</option>
            <option>SAN PIO DE PETRELCINA</option>
        </select-input>
        <text-input v-if="$page.props.auth.user.rol =='Admin'" v-model="form.vale_externo" :error="form.errors.vale_externo" class="pr-6 pb-8 w-full lg:w-2/5" label="Vale Externo(Proveedor)" required disabled/>
        <text-input v-if="$page.props.auth.user.rol =='Admin'" v-model="form.valor_unitario" :error="form.errors.valor_unitario" class="pr-6 pb-8 w-full lg:w-1/5" label="Valor Unitario" required disabled/>
        <text-input v-model="form.observaciones" :error="form.errors.observaciones" class="pr-6 pb-8 w-full lg:w-1/1" label="Observación" disabled/>
        <text-input v-model="form.motivo" :error="form.errors.motivo" class="pr-6 pb-8 w-full lg:w-1/1" label="Motivo Para Anular" required/>

          </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Confirmar Anulación de Orden</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import Datepicker from 'vuejs-datetimepicker'

export default {
  metaInfo() {
    return {
      title: `${this.form.id}`,
    }
  },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
    Datepicker
  },
  layout: Layout,
  props: {
    orden: Object,
    maquinarias: Array,
    proyectos: Array,
    conductores: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
          id: this.orden.id,
        maquinaria_id: this.orden.maquinaria_id,
        proyecto: this.orden.proyecto,
        operador: this.orden.operador,
        material: this.orden.material,
        motivo: this.orden.motivo,
        observaciones: this.orden.observaciones,
        capacidad: this.orden.capacidad,
        proveedor: this.orden.proveedor,
        cliente: this.orden.cliente,
        vale_externo: this.orden.vale_externo,
        valor_unitario: this.orden.valor_unitario
      }),
    }
  },
  methods: {
    update() {
        
      this.form.put(this.route('despachoordenes.destroy', this.orden.id))
    },
  },
}
</script>
